import { get } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table } from "semantic-ui-react";

import FormattedCharge from "./FormattedCharge.jsx";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class EstimateRow extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    dimension: PropTypes.string.isRequired,
    resourceType: PropTypes.string.isRequired,
    estimates: PropTypes.array.isRequired,
    CellComponent: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  // -- RENDER -- //

  renderChargeBlocks = () => {
    const { dimension, resourceType, estimates, CellComponent } = this.props;

    let hasContent = false;

    const blocks = estimates.map((estimate, index) => {
      const chargeData = get(
        estimate,
        `[${resourceType}][${dimension}].charge`,
        undefined
      );

      if (chargeData !== undefined) hasContent = true;

      return (
        <CellComponent key={index} collapsing>
          <FormattedCharge chargeData={chargeData} />
        </CellComponent>
      );
    });

    return hasContent ? blocks : null;
  };

  render = () => {
    const { resourceType, estimates, CellComponent, copyKey, copy } =
      this.props;

    if (!estimates || estimates.length < 1) return null;

    const chargeBlocks = this.renderChargeBlocks();

    if (!chargeBlocks) return null;

    return (
      <Table.Row>
        <CellComponent>
          {copy(`${copyKey}.${resourceType.toLowerCase()}`)}
        </CellComponent>
        {chargeBlocks}
      </Table.Row>
    );
  };
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(EstimateRow);
